export enum Permissions {
  CREATE_USER = 'create:user',
  READ_USER = 'read:user',
  READ_USERS = 'read:users',
  UPDATE_USER = 'update:user',
  ADMIN_PROFILES = 'create:admin_profiles',
  API_CREDENTIALS = 'read:api_credentials'
}
